import config from "../config/config";

var beforeLoginHeaders = {
  "Content-Type": "application/json",
  "api-key": config.APIKEY,
  UDID: getUDID(),
  "device-type": getDeviceType(),
  type: "web"
};
var afterLoginHeaders = {
  "Content-Type": "application/json",
  "api-key": config.APIKEY,
  UDID: getUDID(),
  "device-type": getDeviceType(),
  Authorization: getAccessTokenFromLocalStorage(),
  type: "web"
};

//#region Helper functions for headers
function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
}

function getAccessTokenFromLocalStorage() {
  var accesstoken = "";

  if (localStorage.getItem("user") !== null) {
    var userdata = JSON.parse(localStorage.getItem("user"));
    if (userdata.access_token !== "") accesstoken = userdata.access_token;
    else accesstoken = userdata.data[0].access_token;
  }
  return accesstoken;
}

function getUDID() {
  return window.navigator.userAgent.replace(/\D+/g, "");
}

function getDeviceType() {
  /* var Sys = {};
    var ua = navigator.userAgent.toLowerCase();
    var s;
    (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
        (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
            (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
                (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
                    (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;


    if (Sys.ie) return ('IE: ' + Sys.ie);
    if (Sys.firefox) return ('Firefox: ' + Sys.firefox);
    if (Sys.chrome) return ('Chrome: ' + Sys.chrome);
    if (Sys.opera) return ('Opera: ' + Sys.opera);
    if (Sys.safari) return ('Safari: ' + Sys.safari); */
  return "web";
}
//#endregion

export { beforeLoginHeaders, afterLoginHeaders, handleResponse };
